function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { createPortal } from "react-dom";
import PolizaRenewalForm from "./components/PolizaRenewalForm";
import IndexPolizaRenewalVersions from "./IndexPolizaRenewalVersions";
import { colorStatus } from "./helper/polizaRenewalHelper";
import { useEffect } from "react";
import { fetchPolizaRenewal } from "./actions/PolizaRenewalActions";
import PolizaInfo from "../polizaEndorsements/components/PolizaInfo";
import "./polizaRenewal.scss";

var EditPolizaRenewal = function EditPolizaRenewal(props) {
  var poliza_renewal_id = props.poliza_renewal_id,
      admin = props.admin,
      token = props.token,
      conditions = props.conditions,
      condition_update_reasons = props.condition_update_reasons,
      client_rejects_renewal_reasons = props.client_rejects_renewal_reasons,
      company_rejects_renewal_reasons = props.company_rejects_renewal_reasons;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editingPolizaRenewal = _React$useState2[0],
      setEditingPolizaRenewal = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      historyPortalNode = _React$useState4[0],
      setHistoryPortalNode = _React$useState4[1];

  useEffect(function () {
    fetchPolizaRenewal(poliza_renewal_id).then(function (response) {
      if (response.status == 200) {
        response.json().then(function (data) {
          setEditingPolizaRenewal(data.poliza_renewal);
        });
      }
    });
  }, [poliza_renewal_id]);
  useEffect(function () {
    if (typeof document !== "undefined") {
      var node = document.getElementById("renewal-history-root");
      setHistoryPortalNode(node);
    }
  }, []);

  if (!editingPolizaRenewal) {
    return /*#__PURE__*/React.createElement("p", null, "Cargando renovaci\xF3n de poliza...");
  }

  var poliza = editingPolizaRenewal.poliza;
  var polizaInfoData = poliza ? _objectSpread(_objectSpread({}, poliza), {}, {
    start_date: poliza.start_date ? new Date(poliza.start_date) : null,
    finish_date: poliza.finish_date ? new Date(poliza.finish_date) : null
  }) : null;
  var historySection = /*#__PURE__*/React.createElement("section", {
    className: "renewalHistoryFullWidth"
  }, /*#__PURE__*/React.createElement("div", {
    className: "renewalHistoryContent"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "renewalHistoryTitle"
  }, "Historial de cambios"), /*#__PURE__*/React.createElement(IndexPolizaRenewalVersions, {
    poliza_renewal_id: editingPolizaRenewal.id,
    admin: admin
  })));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid renewalLayout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-header"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("b", null, "Editar renovaci\xF3n de p\xF3liza", poliza !== null && poliza !== void 0 && poliza.code ? " ".concat(poliza.code) : "")), /*#__PURE__*/React.createElement("div", {
    className: "renewalStatusBadge"
  }, colorStatus(editingPolizaRenewal.aasm_state), /*#__PURE__*/React.createElement("span", null, editingPolizaRenewal.status_name))), (poliza === null || poliza === void 0 ? void 0 : poliza.id) && /*#__PURE__*/React.createElement("div", {
    className: "renewalMeta text-muted"
  }, /*#__PURE__*/React.createElement("span", null, "Propuesta #", poliza.id))), polizaInfoData && /*#__PURE__*/React.createElement("div", {
    className: "card renewalInfoCard"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement(PolizaInfo, {
    poliza: polizaInfoData
  })))), /*#__PURE__*/React.createElement("section", {
    className: "renewalFormFullWidth"
  }, /*#__PURE__*/React.createElement("div", {
    className: "renewalFormContent"
  }, /*#__PURE__*/React.createElement(PolizaRenewalForm, {
    polizaRenewal: editingPolizaRenewal,
    token: token,
    conditions: conditions,
    conditionUpdateReasons: condition_update_reasons,
    clientRejectsRenewalReasons: client_rejects_renewal_reasons,
    companyRejectsRenewalReasons: company_rejects_renewal_reasons,
    onChange: function onChange(aPolizaRenewal) {
      setEditingPolizaRenewal(aPolizaRenewal);
    }
  }))), historyPortalNode ? /*#__PURE__*/createPortal(historySection, historyPortalNode) : historySection);
};

export default EditPolizaRenewal;